import styled from '@emotion/styled'

import { transientOptions } from '@f-fertighaus/applications/Next/utils/transientOptions'

export const ElementWrapper = styled('li', transientOptions)<{
  $verticalLayout?: boolean
}>`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  ${({ theme, $verticalLayout }) =>
    $verticalLayout && theme.breakpoints.up('md')} {
    flex-direction: column;
    align-items: center;

    & > div:first-of-type {
      width: 16px;
    }

    & > div:nth-of-type(2) {
      display: block;
      text-align: center;
      margin: 4px 0;

      p {
        white-space: nowrap;
        font-weight: normal;
      }
    }
    & > div:nth-of-type(3) p {
      font-weight: bold;
    }
  }
`

export const IconColumn = styled.div`
  display: flex;
  align-items: flex-start;
  width: 32px;
`
export const NameColumn = styled.div`
  display: flex;
  align-items: flex-start;
  flex-basis: 50%;
  min-width: 115px;

  p {
    line-height: 16px;
  }
`
export const ValueColumn = styled.div`
  flex-basis: 50%;

  p {
    line-height: 1.2;
  }
`

export const DetailValueWithTooltip = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
`
